





































import { defineComponent, PropType, reactive, watch, ref, computed, toRefs } from '@vue/composition-api'
import i18n from './../i18n'

type ListType = { value: string | number; label: string }[]

export default defineComponent({
  name: 'PopupChosen',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    options: {
      type: Array as PropType<ListType>,
      default: () => [],
      required: true
    },
    chosen: {
      type: [String, Number],
      required: true
    },
    search: {
      type: Boolean,
      default: true
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      chosen: '' as string | number
    })
    const { options } = toRefs(props)
    const searchContent = ref('')
    const optionsBySearch = computed(() => {
      return options.value.filter((item) => {
        return i18n.t(item.label).toString().toLocaleLowerCase().includes(searchContent.value.toLocaleLowerCase())
      })
    })
    watch(() => props?.chosen, () => {
      state.chosen = props.chosen
    })
    const handleSearch = (e) => {
      searchContent.value = e
    }
    const handleClick = (chosen: string | number) => {
      state.chosen = chosen
      emit('change', chosen)
      handleClose()
    }
    const handleClose = () => {
      emit('input', false)
    }

    return {
      props,
      handleSearch,
      optionsBySearch,
      handleClick,
      handleClose
    }
  }
})
